var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9,14.1L11.1,16l-8-8l8-8l1.9,1.9L6.8,8L12.9,14.1z","fill":"currentColor"}));
}

ChevronLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
